<template>
  <div class="view-login">
    <div class="animate-right">
      <h2 class="text-semibold">Login</h2>

      <p>Seja Bem-vindo de volta!</p>
    </div>
    <form class="d-flex flex-column gap-4" @submit.prevent="submit">
      <snow-input
        v-model="form.email"
        label="E-mail"
        id="email"
        type="email"
        :rules="rules.email"
      />

      <snow-input
        v-model="form.password"
        label="Senha"
        id="password"
        type="password"
        :rules="rules.password"
      />
      <p class="text-right fs-14 mb-0 animate-left">
        <router-link :to="{ name: 'forgot-password' }">
          Esqueceu sua senha?
        </router-link>
      </p>

      <button
        class="btn mb-3"
        :class="{ loading }"
        type="submit"
        :disabled="loading"
        :aria-busy="loading"
        @click="submit"
      >
        <span v-if="!loading">Entrar</span>
        <span v-else class="spinner" aria-hidden="true"></span>
        <span v-if="loading" class="sr-only">Carregando…</span>
      </button>

      <p class="text-center mb-0">
        Não tem uma conta?
        <router-link :to="{ name: 'register' }">Cadastre-se</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  components: {},
  name: "login",
  data() {
    return {
      ...formFields(["email", "password"]),
      loading: false,
      rules: {
        email: [
          v => !!v || "O e-mail é obrigatório",
          v => /.+@.+\..+/.test(v) || "E-mail deve ser válido"
        ],
        password: [
          v => !!v || "A senha é obrigatória",
          v =>
            (v && v.length >= 6) || "A senha deve conter no mínimo 6 caracteres"
        ]
      }
    };
  },
  methods: {
    setError(error, field) {
      this.errors[field] = error;
    },
    register() {
      this.$dataLayer.push({
        event: "select_content"
      });
    },
    submit() {
      this.$message.hide();
      this.loading = true;

      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(
            window.RECAPTCHA_ENTERPRISE_SITE_KEY,
            { action: "LOGIN" }
          );
          this._submit(token);
        } catch {
          this.loading = false;
          this.$message.error("Por favor, tente novamente");
        }
      });
    },
    _submit(recaptcha_token) {
      this.$store
        .dispatch("user/login", {
          ...this.form,
          recaptcha_token
        })
        .then(response => {
          this.$store.dispatch("postLogin").catch(() => {
            this.$router.replace({
              name: "login",
              query: { path: this.$route.fullPath }
            });
          });
          if (this.$route.query.path) {
            this.$router.push(this.$route.query.path);
          } else {
            this.$router.push({ name: "home" });
          }
          this.$dataLayer.push({
            event: "login",
            name: response.name,
            email: response.email
          });
        })
        .catch(error => {
          if (!error.response.data.non_field_errors) {
            Object.keys(error.response.data).forEach(field => {
              this.errors[field] = error.response.data[field];
            });
          } else {
            this.$message.error(error.response.data.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-login {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
